import { extend } from 'vee-validate';

extend('alphanumeric', {
  validate: (value) => {
    return {
      required: true,
      // Only alphabets and numeric
      valid: /^[a-zA-Z0-9]+$/.test(value),
    };
  },
  computesRequired: true,
});
